<template>
    <nav v-if="categories?.length" class="flex lg:flex-wrap gap-0.5 -mr-3 sm:-mr-6 lg:mr-0 overflow-x-auto lg:mt-0 lg:overflow-visible">
        <NuxtLinkLocale
            :to="{ name: 'blog' }"
            class="px-2 py-0.75 rounded-full text-15 lg:text-base leading-4.5 text-brand-dark-blue transition-colors"
            :class="isAllActive
               ? 'bg-brand-light-blue'
               : 'hover:bg-brand-light-blue'"
        >
            {{ t('blog.all') }}
        </NuxtLinkLocale>
        <NuxtLinkLocale
            v-for="cat in categories"
            :key="cat.id"
            :to="`/blog/${cat.url}/`"
            class="px-2 py-0.75 rounded-full text-15 lg:text-base leading-4.5 text-brand-dark-blue transition-colors"
            :class="isActive(cat.url)
               ? 'bg-brand-light-blue'
               : 'hover:bg-brand-light-blue'"
        >
            {{ cat.name }}
        </NuxtLinkLocale>
    </nav>
</template>

<script setup lang="ts">
import type { BlogCategory } from '~/types'

const props = defineProps<{
    categories: BlogCategory[]
}>()

const route = useRoute()
const { t } = useI18n()

const isAllActive = computed(() => !props.categories.some(cat => route.path.includes(`/blog/${cat.url}`)))

function isActive(url: string) {
    return route.path.includes(`/blog/${url}`)
}
</script>
